<!--停车场管理-->
<template>
  <div>
    <div class="panel panel-default panel-search">
      <el-form :inline="true">
        <el-form-item>
          <div slot="label">
            <el-select v-model="dateRangeType" style="width:120px" class="formitem-label">
              <el-option value="activeOn" label="激活时间"></el-option>
              <el-option value="useOn" label="使用时间"></el-option>
              <el-option value="createOn" label="记录时间"></el-option>
            </el-select>
          </div>

          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="商户">

          <merchant-select
            v-model="page.query.param.merchantId"
            :clearable="true"
          ></merchant-select>

        </el-form-item>-->
        <el-form-item label="使用状态">
          <el-select v-model="page.query.param.useStatus" :clearable="true">
            <el-option
              v-for="item in $dict.store.COUPON_STATUS"
              :key="item[0]"
              :label="item[1]"
              :value="item[0]"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="券号">
          <el-input v-model="page.query.param.sn" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" v-keycode="'ENTER'">查询</el-button>
          <el-button type="success" @click="search" v-keycode="'ENTER'">导出</el-button>

        </el-form-item>
      </el-form>
    </div>

    <v-table ref="table" :page="page" :table-minheight="450">
      <el-table-column prop="sn" label="券号" width="120"></el-table-column>

      <el-table-column prop="batchNo" label="批次号" width="120"></el-table-column>

      <el-table-column prop="name" label="名称">
        <template slot-scope="{row}">
          [{{row.promotionInfo.name}}]-{{row.promotionInfo.discountCondition}}
          <span
            style="color:gray"
          >{{row.promotionInfo.tip}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="activeOn" label="激活时间" width="150"></el-table-column>
      <el-table-column prop="endOn" label="截止时间" width="150"></el-table-column>
      <el-table-column prop="dispatchChannelName" label="派发渠道" width="140"></el-table-column>
      <el-table-column prop="status" label="激活状态" width="120">
        <template slot-scope="{row}">
          {{row.activeStatus==0?'未激活':'已激活'}}
           <span
            v-show="row.activeStatus"
          >[{{row.activeKey}}]</span>
          <el-button
            v-show="!row.activeStatus"
            type="text"
            icon="el-icon-share"
            title="激活"
            @click="dispatch2User(row)"
          ></el-button>
        </template>
      </el-table-column>

      
      <el-table-column prop="status" label="使用状态" width="80">
        <template slot-scope="{row}">{{$dict.getText(row.useStatus,$dict.store.COUPON_STATUS)}}</template>
      </el-table-column>
      <el-table-column prop="status" label="使用用户" width="140">
        <template slot-scope="{row}">{{row.username}}</template>
      </el-table-column>
      <el-table-column prop="status" label="使用订单号" width="120">
        <template slot-scope="{row}">{{row.useOrderno}}</template>
      </el-table-column>
      <el-table-column prop="createOn" width="140" label="创建时间">
        <template slot-scope="{row}">{{row.createOn}}</template>
      </el-table-column>
    </v-table>
    <v-dialog ref="formDiag" title="生成优惠券" width="500px">
      <form-panel @saved="onFormSaved"></form-panel>
      <div slot="footer">
        <el-button type="primary" @click="$refs.formDiag.dispatch('submit')">保存</el-button>
      </div>
    </v-dialog>

    <v-dialog ref="dispatchFormDiag" title="优惠券激活" width="500px">
      <dispatch-form-panel @saved="onFormSaved2"></dispatch-form-panel>
      <div slot="footer">
        <el-button type="danger" @click="$refs.dispatchFormDiag.dispatch('submit')">确定激活</el-button>
      </div>
    </v-dialog>
  </div>
</template>
<style rel="stylesheet/less" scoped lang="less">
</style>
<script>
import MerchantSelect from "@/components/widgets/MerchantSelect.vue";

import FormPanel from "./Form";

import DispatchFormPanel from "./DispatchForm";

export default {
  components: {
    FormPanel,

    DispatchFormPanel,

    MerchantSelect
  },

  data() {
    return {
      dateRangeType: "createOn",
      dateRange: [],
      formStatus: 1,

      orderDateRange: [],

      summaryMap: {},

      page: {
        query: {
          orderBys: "id|desc",

          param: {
            isDeleted: false
          }
        },

        getData: this.$api.ipark.PromotionCouponService.query
      },

      tableActions: [
        {
          name: "编辑",

          handle: this.edit
        },

        {
          name: "删除",

          handle: this.del,

          style: "color:red"
        }
      ]
    };
  },

  computed: {},

  methods: {
    create() {
      this.$refs.formDiag.show();
    },

    edit(row) {
      this.$refs.formDiag.show({
        id: row.id
      });
    },

    del(row) {
      this.$confirm("确定删除此条记录吗?", "提示", {
        type: "warning"
      }).then(() => {
        this.$api.ipark.MerchantInfoService.delete(row.id).then(rsp => {
          this.search();

          this.$message({
            type: "success",

            message: "删除成功!"
          });
        });
      });
    },

    onFormSaved(r) {
      this.$message("生成成功！批次号:" + r);

      this.$refs.formDiag.hide();

      this.$nextTick(this.search);
    },

    onFormSaved2() {
      this.$refs.dispatchFormDiag.hide();

      this.search();
    },

    dispatch2User(row) {
      this.$refs.dispatchFormDiag.show({
        coupon: row
      });
    },

    init(options = {}) {
      console.log(options);
      Object.assign(this.page.query,options.query);
      this.search();
    },

    search() {
      this.page.query.dateRanges = {};
      if (this.dateRangeType != null && this.dateRange&&this.dateRange.length>0) {
        
        this.page.query.dateRanges[this.dateRangeType] = {
          startDate: this.dateRange[0],

          endDate: this.dateRange.length > 1 ? this.dateRange[1] : null
        };
      }
      this.$refs.table.load();
    }
  },

  created() {},

  mounted() {
    this.$on("init", this.init);
  }
};
</script>



// WEBPACK FOOTER //
// Manage.vue?7754955d